import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import * as authApi from 'shared/api/auth/authApi';

/**
 * Страница подтверждения email
 * Обрабатывает токен из URL и отправляет запрос на верификацию
 */
const EmailVerification = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('Токен подтверждения не найден в URL');
      return;
    }

    const verifyEmail = async () => {
      try {
        await authApi.verifyEmail(token);
        setStatus('success');
        
        // Редирект на логин через 3 секунды
        setTimeout(() => {
          navigate('/login', {
            state: {
              message: 'Email успешно подтверждён! Теперь вы можете войти в систему.',
              type: 'success'
            }
          });
        }, 3000);
      } catch (err) {
        console.error('Email verification failed:', err);
        setStatus('error');
        if (err.status === 400) {
          setError('Недействительная или истёкшая ссылка подтверждения');
        } else if (err.status === 404) {
          setError('Пользователь не найден');
        } else {
          setError(err.message || 'Не удалось подтвердить email');
        }
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md text-center">
        {/* Loading */}
        {status === 'loading' && (
          <div>
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="Loader2" size={40} className="text-primary animate-spin" />
            </div>
            <h1 className="text-2xl font-semibold text-text-primary mb-2">
              Подтверждение email
            </h1>
            <p className="text-text-secondary">
              Пожалуйста, подождите...
            </p>
          </div>
        )}

        {/* Success */}
        {status === 'success' && (
          <div>
            <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckCircle" size={40} className="text-success" />
            </div>
            <h1 className="text-2xl font-semibold text-text-primary mb-2">
              Email подтверждён!
            </h1>
            <p className="text-text-secondary mb-6">
              Ваш email успешно подтверждён. Вы будете перенаправлены на страницу входа.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-md hover:bg-primary-700 transition-colors duration-150"
            >
              Перейти к входу
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>
        )}

        {/* Error */}
        {status === 'error' && (
          <div>
            <div className="w-20 h-20 bg-error/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="XCircle" size={40} className="text-error" />
            </div>
            <h1 className="text-2xl font-semibold text-text-primary mb-2">
              Ошибка подтверждения
            </h1>
            <p className="text-text-secondary mb-6">
              {error}
            </p>
            <div className="space-y-3">
              <Link
                to="/login"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-md hover:bg-primary-700 transition-colors duration-150"
              >
                Вернуться к входу
              </Link>
              <div>
                <Link
                  to="/register"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-150"
                >
                  Зарегистрироваться заново
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
